
export default {
  name: 'ProductContextMenu',
  props: {
    items: Array,
  },
  data() {
    return {
      show: false,
      dontBlur: false,
      x: 0,
      y: 0,
      heightItem: 25,
      widthContextMenu: 140,
      offsetLayerX: 13,
      offsetLayerY: 20,
      toleranceX: 25,
      toleranceY: 35,
      itemsContextMenu: [
        {
          label: 'components.productListItem.editProduct',
          link: this.urlToAdminPage(),
        },
      ],
    }
  },

  methods: {
    openLink(link) {
      window.open(link, '_blank')
      this.hideMenu(true)
    },
    showMenu(e) {
      this.x = e.layerX + this.offsetLayerX
      this.y = e.layerY + this.offsetLayerY

      if (
        this.x >=
        this.$refs.listItem.parentElement.offsetWidth -
          this.widthContextMenu +
          this.toleranceX
      )
        this.$refs.listItem.style.left = `${this.x - this.widthContextMenu}px`
      else this.$refs.listItem.style.left = `${this.x}px`

      if (
        this.y >=
        this.$refs.listItem.parentElement.offsetHeight -
          this.heightItem * this.items.length -
          this.toleranceY
      ) {
        this.$refs.listItem.style.top = `${
          this.y - this.heightItem * (this.items.length + 1.1)
        }px`
      } else this.$refs.listItem.style.top = `${this.y}px`

      this.show = true
      this.dontBlur = false
      this.$refs.listItem.focus()
    },
    hideMenu(forceHide = false) {
      if (!this.dontBlur || forceHide) {
        this.show = false
        this.dontBlur = false
      }
    },
  },
}
